module.exports = __webpack_public_path__ + "static/media/inara_logo.79718dfa.svg";